import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';

export const updateGlossaryTermSynonyms = async (
  termId: string,
  newSynonyms: string[],
  currentSynonyms: string[]
): Promise<void> => {
  try {
    if (!termId) {
      throw new Error('Glossary term ID is required');
    }

    const operations: JsonPatchOperation[] = [];

    const currentSet = new Set(currentSynonyms);
    const newSet = new Set(newSynonyms);

    const toRemove = currentSynonyms.filter((s) => !newSet.has(s));
    const toAdd = newSynonyms.filter((s) => !currentSet.has(s));

    toRemove.forEach((synonym) => {
      const index = currentSynonyms.indexOf(synonym);
      if (index !== -1) {
        operations.push({
          op: 'remove',
          path: `/synonyms/${index}`,
        });
      }
    });

    if (toRemove.length > 0 && toAdd.length > 0) {
      operations.push({
        op: 'replace',
        path: '/synonyms',
        value: newSynonyms,
      });
    } else if (toRemove.length === 0 && toAdd.length > 0) {
      toAdd.forEach((synonym) => {
        operations.push({
          op: 'add',
          path: `/synonyms/${currentSynonyms.length + operations.filter((op) => op.op === 'add').length}`,
          value: synonym,
        });
      });
    }

    if (operations.length > 0) {
      await openMetadataApiClient.patch(`/glossaryTerms/${encodeURIComponent(termId)}`, operations, {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      });
    }
  } catch (error) {
    console.error('Failed to update glossary term synonyms:', error);
    throw error;
  }
};
